/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  IResponseListSites,
  IResponseShowSite,
  ISite,
} from "../../interfaces/sites";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/sites";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listSites({
  includes,
  filter,
  page,
  limit,
  select,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListSites>(BASE, {
    params: { includes, filter, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showSite({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowSite>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createSite({ site }: { site: ISite }) {
  const { data } = await api.post<IResponseShowSite>(BASE, { site });
  return data;
}

export async function updateSite({
  id,
  site,
}: {
  id: string | number;
  site: ISite;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowSite>(url, { site });
  return data;
}

export async function getTopCustomers(filter?: any) {
  const { data } = await api.get(`${BASE}/dashboard/top-customers`, { params: filter });
  return data;
}

export async function getTopStates(filter?: any) {
  const { data } = await api.get(`${BASE}/dashboard/top-states`, { params: filter });
  return data;
}

export async function getTopTypes(filter?: any) {
  const { data } = await api.get(`${BASE}/dashboard/top-types`, { params: filter });
  return data;
}

export async function getActiveCount(filter?: any) {
  const { data } = await api.get(`${BASE}/dashboard/active-count`, { params: filter });
  return data;
}

export async function getNearCoastCount(filter?: any) {
  const { data } = await api.get(`${BASE}/dashboard/near-coast`, { params: filter });
  return data;
}

export async function deleteSite({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
